import React, { useState, useEffect } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import CursoCard from '../../components/Cursos/CursoCard';
import { listarCursos } from '../../services/cursoService';

const ListaCursosPage = () => {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const data = await listarCursos();
        console.log('Cursos recebidos:', data); // Log para verificar dados

        let cursosArray = [];

        if (Array.isArray(data)) {
          cursosArray = data;
        } else if (data && Array.isArray(data.cursos)) {
          cursosArray = data.cursos;
        } else {
          console.error('Formato de dados inesperado:', data);
          setErro('Formato de dados inesperado.');
        }

        // Filtra cursos válidos
        const cursosValidos = cursosArray.filter(curso => curso && curso.id);
        setCursos(cursosValidos);
      } catch (error) {
        console.error('Erro ao buscar cursos:', error);
        setErro('Erro ao buscar cursos.');
      } finally {
        setLoading(false);
      }
    };

    fetchCursos();
  }, []);

  if (loading) {
    return <Typography>Carregando cursos...</Typography>;
  }

  if (erro) {
    return <Typography color="error">{erro}</Typography>;
  }

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Cursos
      </Typography>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item>
          <Button
            component={Link}
            to="/dashboard"
            variant="outlined"
            color="secondary"
          >
            Voltar ao Dashboard
          </Button>
        </Grid>
        <Grid item>
          <Button
            component={Link}
            to="/cursos/criar"
            variant="contained"
            color="primary"
          >
            Adicionar Novo Curso
          </Button>
        </Grid>
      </Grid>
      {cursos.length > 0 ? (
        <Grid container spacing={3}>
          {cursos.map((curso) => (
            <Grid item key={curso.id} xs={12} sm={6} md={4}>
              <CursoCard curso={curso} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography>Nenhum curso encontrado.</Typography>
      )}
    </div>
  );
};

export default ListaCursosPage;
